<template>
  <div class="purchase_order">
    <v-container grid-list-xl fluid>
      <v-layout wrap row>
        <v-flex xs12>
          <Title title="Purchase Order">
            <div slot="widget-content">
              <div>
                <p v-if="errors.length">
                  <v-alert
                    :value="true"
                    color="primary"
                    type="error"
                    dismissible
                    outline
                    >{{ errors }}</v-alert
                  >
                </p>

                <p v-if="pdferrors.length">
                  <v-alert
                    :value="true"
                    color="primary"
                    type="error"
                    dismissible
                    outline
                    >{{ pdferrors }}</v-alert
                  >
                </p>
                <v-layout row wrap>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color: #0cabc2">Action</span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-flex xs3>
                    <v-dialog
                      v-model="new_po_dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <v-btn color="primary" slot="activator">New PO</v-btn>

                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-toolbar-title>New PO</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn icon dark @click="new_po_dialog = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                        <NewPOForm @update="fetch_po_date_picker()"></NewPOForm>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout wrap row>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color: #0cabc2">Previous PO</span>
                    </v-toolbar-title>
                  </v-toolbar>

                  <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="farmer"
                      :items="farmerList"
                      item-text="name"
                      item-value="name"
                      label="Farmer"
                      persistent-hint
                      small-chips
                      solo
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-checkbox
                      v-model="checkbox_price"
                      label="print with price"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="currency"
                      :items="currencyList"
                      item-text="name"
                      item-value="value"
                      label="Currency"
                      persistent-hint
                      small-chips
                      solo
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs6></v-flex>
                  <v-flex xs6>
                    <datepicker
                      ref="datepicker"
                      @update="fetch_po_date_picker()"
                    ></datepicker>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex >
                    <div style="text-align:center">
                     <v-progress-circular
                        indeterminate
                        :size="30"
                        color="primary"
                     
                        v-if="po_loading"
                        style="margin-bottom:14px"
                      ></v-progress-circular>

                         <v-pagination
                  v-model="po_list_page"
                  :length="po_list_length"
                ></v-pagination>
                </div>
                  </v-flex>
                </v-layout>
                 <v-layout>
                  <v-btn color="warning" v-if="selected.length>0" @click="fetch_array_for_bulk_print()">print</v-btn>
                </v-layout>
                <v-data-table
                  :headers="headers"
                  :items="po_list_array"
                  :search="farmer"
                  :disable-initial-sort="true"
                  hide-actions
                  active-class="highlighted"
                  class="elevation-5"
                  select-all
                  v-model="selected"
                > 
                <template v-slot:headers="props">
                    <tr>
                      <th>
                        <v-checkbox
                          :input-value="props.all"
                          :indeterminate="props.indeterminate"
                          primary
                          hide-details
                          @click.stop="toggleAll"
                        ></v-checkbox>
                      </th>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                      ></th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr
                     :active="props.selected"
                      @click="props.selected = !props.selected">
                       <td  width="4%">
                        <v-checkbox
                          :input-value="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td width="8%"  class="text-xs">
                        <b>{{ props.item.prefix_id }}</b>
                      </td>
                      <td width="8%" class="text-xs">
                        <b>{{ props.item.ref_no }}</b>
                      </td>
                      <td width="8%"class="text-xs">
                        <b>{{ props.item.created_at }}</b>
                      </td>
                      <td width="20%" class="text-xs">
                        <b>{{ props.item.farmer_name }}</b>
                      </td>
                      <td width="8%" class="text-xs">{{ props.item.driver_name }}</td>
                      <td width="8%" class="text-xs">
                        <v-chip
                          outline
                          x-large
                          :color="
                            props.item.invoice_status == '0'
                              ? '#48b24ff2'
                              : props.item.invoice_status == '1'
                              ? '#ff0000a6'
                              : '#48b24ff2'
                          "
                          >{{ props.item.invoice_status_name }}</v-chip
                        >
                      </td>

                      <td width="10%" class="text-xs">
                        <v-btn
                          @click="
                            fetch_sewa_for_print(
                              props.item.id,
                              props.item.created_at,
                              props.item.farmer_name
                            )
                          "
                          >print Sewa</v-btn
                        >
                        <v-btn
                          @click="
                            fetch_array_for_print(
                              props.item.id,
                              props.item.created_at,
                              props.item.farmer_name,
                              props.item.basket_type,
                              props.item.basket_quantity,
                              props.item.ref_no
                            )
                          "
                          >print PO</v-btn
                        >
                      </td>
                      <td width="20%" class="text-xs">
                        <v-icon
                          medium
                          color="warning"
                          @click="
                            get_po_detail(
                              props.item.id,
                              props.item.created_at,
                              props.item.farmer_id
                            )
                          "
                          >build</v-icon
                        >
                        <v-icon
                          medium
                          color="error"
                          @click="deletePO(props.item.id)"
                          >delete_forever</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-layout wrap row>
                  <v-flex >
                    <div style="text-align:center">
                     <v-progress-circular
                        indeterminate
                        :size="30"
                        color="primary"
                     
                        v-if="po_loading"
                        style="margin-bottom:14px"
                      ></v-progress-circular>

                         <v-pagination
                  v-model="po_list_page"
                  :length="po_list_length"
                ></v-pagination>
                </div>
                  </v-flex>
                </v-layout>

                <v-snackbar v-model="snackbar" :top="true">
                  No Internet Connection
                  <v-btn color="pink" flat @click="snackbar = false"
                    >Close</v-btn
                  >
                </v-snackbar>
              </div>
            </div>
          </Title>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="po_item_dialog" v-if="po_item_dialog">
      <v-card>
        <v-card-title>
          <span class="headline">PO Details</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <po_table  ref="po_table" @update="fetch_po_date_picker()"></po_table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="po_item_dialog = false"
          >
            Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/jspdf"></script>
<script src="https://cdn.jsdelivr.net/npm/vxe-table-plugin-export-pdf/fonts/source-han-sans-normal.js"></script>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Title from "@/components/widget/title";
import NewPOForm from "@/views/Create_purchase_order";
import po_table from "@/components/large_component/po_table";
import datepicker from "@/components/widget/datepicker";

export default {
  components: {
    //  small_list,
    Title,
    NewPOForm,
    po_table,
    datepicker,
  },
  data: () => ({
    search: "",
    isLoading: true,
    snackbar: false,
    errors: "",
    pdferrors: "",
    refresh: true,
    baseUrl: baseUrl,
    date_now: moment().format("DD-MM-YYYY"),
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),

    selected_farmer_name: "",
    selected_farmer_address: "",
    selected_driver_name: "",
    selected_po_id: "",
    VegeLogo: "",
    CheckBox: "",
    date_box: false,

    date: moment().format("YYYY-MM-DD"),
    farmerList: [],
    farmer: "",
    po_item_dialog: false,
    headers: [
      { text: "ID", align: "", value: "prefix_id" },
      { text: "Ref", align: "", value: "ref_no" },
      { text: "Date", align: "", value: "created_at" },
      { text: "Farmer", align: "", value: "farmer_name" },
      { text: "Driver", align: "", value: "driver_name" },
      { text: "Status", align: "", value: "invoice_status_name" },
      { text: "Print", align: "", value: "" },
      { text: "Tool", align: "left", value: "" },
    ],
    po_list_array: [],
    fetched_one_po_array: [],
    po_array_for_print: [],
    sewa_array_for_print: [],

    new_po_dialog: false,

    formatted_array2: [],
    own_basket: "",
    basket_in_quantity: "",
    checkbox_price: false,
    currencyList: [
      { name: "RM", value: "RM" },
      { name: "SGD", value: "$" },
    ],
    currency: "RM",

    po_list_page:1,
    po_list_length:1,
    po_loading:false,

    selected:[],
  }),

  computed: {},

  watch: {
    farmer(){
      this.po_list_page=1;
      this.fetch_po_date_picker();
    }
    ,po_list_page(){
      this.fetch_po_date_picker();

    }
  },

  created() {
    this.getImageLogo();
    this.getFarmer();
    this.fetch_po(this.start_date, this.end_date);
  },

  methods: {
    getFarmer() {
      const params = new URLSearchParams();
      params.append("get_farmer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_farmer.php",
        data: params,
      })
        .then((response) => {
          if (response.data.error == false) {
            this.farmerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Farmer List Problem" + response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },

    // intervalFetchData: function() {
    //   setInterval(() => {
    //     this.fetch_po();
    //   }, 500);
    // },
    fetch_po_date_picker() {
      this.fetch_po(this.$refs.datepicker.date1, this.$refs.datepicker.date2);
    },
    fetch_po: function (start_date, end_date) {
        if(this.start_date!==start_date || this.end_date!==end_date){
        this.po_list_page=1;
        this.start_date=start_date;
        this.end_date=end_date;
      }
      this.po_loading=true;

      const params = new URLSearchParams();
      params.append("getPurchaseOrderList", "getPurchaseOrderList");
      params.append("start_date", start_date);
      params.append("end_date", end_date);
      params.append("page", this.po_list_page);
      params.append("search", this.farmer);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params,
      })
        .then((response) => {
          this.po_loading=false;
          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            this.po_list_array = response.data.data;
             this.po_list_length = response.data.po_list_length;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.po_list_array = [];
            this.po_list_length = 1;
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    get_po_detail(po_id, po_date, farmer_id) {
      this.po_item_dialog = true;
      console.log('hehe');

      this.$nextTick(() => {
                            this.$refs.po_table.getPOStock(po_id, po_date, farmer_id);

                  })
      // this.$refs.po_table.getPOStock(po_id, po_date, farmer_id);
      // this.$refs.po_table.getFarmer();

      // this.$refs.po_table.forEach(i => i.getPOStock(po_id, po_date, farmer_id));
      console.log('open po ');
    },
    getImageLogo() {
      const toDataURL = (url) =>
        fetch(url)
          .then((response) => response.blob())
          .then(
            (blob) =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
          );

      toDataURL(require("@/assets/image/vege_trading.jpg")).then((dataUrl) => {
        this.VegeLogo = dataUrl;
      });

      toDataURL(require("@/assets/image/checkbox.png")).then((dataUrl) => {
        this.CheckBox = dataUrl;
      });
    },

    fetch_array_for_print(
      po_id,
      date,
      farmer_name,
      basket_type,
      basket_quantity,
      ref_id
    ) {
      const params = new URLSearchParams();
      params.append("getPOStock", "getPOStock");
      params.append("po_id", po_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            this.po_array_for_print = response.data.data;
            // this.print_po(
            //   po_id,
            //   date,
            //   farmer_name,
            //   basket_type,
            //   basket_quantity
            // );
            this.check_own_basket(
              po_id,
              date,
              farmer_name,
              basket_type,
              basket_quantity,
              ref_id
            );
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.po_array_for_print = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },

    fetch_array_for_bulk_print() {
      const params = new URLSearchParams();
      params.append("getbulkpo", "getPOStock");
      params.append("po_ids", JSON.stringify(this.selected));

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            console.log('bulk print result');
            console.log(response.data.data);

            this.print_bulk_po(response.data.data);
          } else if (response.data.error == true) {
            this.errors = response.data.message;
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_sewa_for_print(po_id, date, farmer_name) {
      const params = new URLSearchParams();
      params.append("sewa", "sewa");
      params.append("po_id", po_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            this.sewa_array_for_print = response.data.data;
            // console.log( JSON.stringify( this.sewa_array_for_print));

            if (parseFloat(this.sewa_array_for_print[0].total_weight) > 0) {
              this.print_sewa(po_id, date, farmer_name);
            }
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.sewa_array_for_print = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    print_po(po_id, date, farmer_name, basket_type, basket_quantity, ref_id) {
      // var newarray = [];

      // for (var i = 0; i < this.po_array_for_print.length; i++) {
      //   var product_name = this.po_array_for_print[i].product_name;
      //   var grade = this.po_array_for_print[i].grade;
      //   var location = this.po_array_for_print[i].location;
      //   var weight = this.po_array_for_print[i].weight;
      //   var quantity = this.po_array_for_print[i].quantity;
      //   var deduction_weight = this.po_array_for_print[i].deduction_weight;
      //   var deduction_quantity = this.po_array_for_print[i].deduction_quantity;
      //   var total_weight = this.po_array_for_print[i].total_weight;

      //   if (deduction_weight > 0 && deduction_quantity > 0) {
      //     newarray.push({
      //       product_name: product_name,
      //       grade: grade,
      //       location: location,
      //       weight: weight,
      //       quantity: quantity
      //     });

      //     newarray.push({
      //       product_name: "",
      //       grade: "",
      //       location: "Deduct",
      //       weight: "-" + deduction_weight,
      //       quantity: deduction_quantity
      //     });
      //   } else {
      //     newarray.push({
      //       product_name: product_name,
      //       grade: grade,
      //       location: location,
      //       weight: weight,
      //       quantity: quantity
      //     });
      //   }
      // }

      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 17, 23, 23);

      // doc.setFontSize(14);
      // doc.setFontStyle("bold");
      // doc.text(145, 10, "PURCHASE BILL   :");
      // doc.setLineWidth(0.4);
      // doc.line(145, 11, 190, 11);
      // const myFont = fontjs ;// load the *.ttf font file as binary string


      // doc.addFileToVFS("SourceHanSans-Normal.ttf");      
      // doc.addFont("SourceHanSans-Normal.ttf", "SourceHanSans-Normal", "normal");
      // doc.setFont("SourceHanSans-Normal");
      // doc.text(41, 30, "简体中文、繁體体中文、English、ジャパン、한국어");

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);

    doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(165, 15, "ID: ");

      doc.text(158, 20, "Date: ");
      doc.text(153, 25, "Farmer: ");

      // doc.setFontStyle("normal");
      // doc.text(173, 15, "NO: ");

      // if (basket_type == "Basket given") {
      //   doc.text(142, 40, "Basket given:  " + basket_quantity);
      // } else if (basket_type == "Basket returned") {
      //   doc.text(137, 40, "Basket returned:  " + basket_quantity);
      // }

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(171, 15, "#PO" + po_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, date);
      // doc.text(181, 15, "#" + (ref_id==null?"":ref_id));

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(farmer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(15, 45, "Purchase Bill:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(15, 52, "#" + ref_id);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(55, 45, date);
      doc.setLineWidth(0.3);
      doc.line(15, 54, 192, 54);

      doc.setLineWidth(0.4);
      doc.line(120, 35, 192, 35);
      doc.line(120, 52, 192, 52);
      doc.line(120, 35, 120, 52);
      doc.line(192, 35, 192, 52);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(123, 42, "B/F:");
      // doc.text(158, 42, "OUT:");
      doc.text(123, 48, "IN:");
      doc.text(158, 48, "BALANCE:");

      var basket_in_current_po = 0;
      for (var i = 0; i < this.po_array_for_print.length; i++) {
        basket_in_current_po =
          basket_in_current_po +
          (this.po_array_for_print[i].basket_item_quantity == null
            ? 0
            : parseFloat(this.po_array_for_print[i].basket_item_quantity));
      }

      if (basket_type == "Basket given") {
        doc.text(158, 42, "OUT:  " + basket_quantity);
      } else if (basket_type == "Basket returned") {
        doc.text(158, 42, "IN(empty):  " + basket_quantity);
      }

      var balance = 0;

      // doc.setFontStyle("normal");
      // doc.text(167, 42, (isNaN(out)|| out== null?0:out).toString());
      doc.text(
        132,
        42,
        (isNaN(this.own_basket) ||
        this.own_basket == null ||
        this.own_basket == 0
          ? ""
          : this.own_basket
        ).toString()
      );
      doc.text(
        132,
        48,
        (isNaN(basket_in_current_po) ||
        basket_in_current_po == null ||
        basket_in_current_po == ""
          ? 0
          : basket_in_current_po
        ).toString()
      );

      var own_minus_vege_basket =
        parseFloat(
          isNaN(this.own_basket) || this.own_basket == null
            ? 0
            : this.own_basket
        ) -
        parseFloat(
          isNaN(basket_in_current_po) || basket_in_current_po == null
            ? 0
            : basket_in_current_po
        );
      if (basket_type == "Basket given") {
        // doc.text(158, 42, "OUT:  " + basket_quantity);
        balance = own_minus_vege_basket + basket_quantity;
      } else if (basket_type == "Basket returned") {
        balance = own_minus_vege_basket - basket_quantity;

        // doc.text(158, 42, "IN(empty):  " + basket_quantity);
      } else {
        balance = own_minus_vege_basket;
      }

      doc.text(178, 48, balance.toString());

      this.formatted_array2 = [];
      var formatted_array = [];
      var total_amount = 0;
      for (var i = 0; i < this.po_array_for_print.length; i++) {
        formatted_array[i] = this.po_array_for_print[i];

        console.log(this.po_array_for_print[i].total_real_weight);

        var price_float = parseFloat(this.po_array_for_print[i].price).toFixed(2);
        var total_real_weight_float = parseFloat(
          this.po_array_for_print[i].total_real_weight
        );
        var sub_total =  parseFloat(parseFloat(price_float) * total_real_weight_float).toFixed(2);

        total_amount = parseFloat(total_amount) + parseFloat(sub_total);
        this.$set(formatted_array[i], "sub_total", parseFloat(sub_total).toFixed(2));
        // this.$set(formatted_array[i], "row_no", i + 1);
      }

      for (var g = 0; g < formatted_array.length; g++) {
        this.find(
          formatted_array[g].product_name,
          formatted_array[g].grade,
          formatted_array[g].location,
          formatted_array[g].weight,
          formatted_array[g].quantity,
          formatted_array[g].product_id,
          formatted_array[g].basket_item_quantity,
          formatted_array[g].total_real_weight,
          formatted_array[g].sub_total,
          formatted_array[g].price
        );

        if(g==formatted_array.length-1){
          for(var z=0; z<this.formatted_array2.length; z++){
            
            var split_array = this.formatted_array2[z].weight.split(",");

            if(split_array[0]=='box'){
              this.formatted_array2[z].weight=split_array.length +'box';
            }
            if(split_array[0]=='pkt'){
              this.formatted_array2[z].weight=split_array.length +'pkt';
            }
            if(split_array[0]=='pcs'){
              this.formatted_array2[z].weight=split_array.length +'pcs';
            }
            if(split_array[0]=='bag'){
              this.formatted_array2[z].weight=split_array.length +'bag';
            }

          }
        }
      }

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        //  { header: "Basket?", dataKey: "basket_used" },
        { header: "Total Weight", dataKey: "total_real_weight" },
      ];

      var grade_array = { header: "Grade", dataKey: "grade" };
      var location_array = { header: "Location", dataKey: "location" };
      var price_array = { header: "Price/kg", dataKey: "price" };
      var Amount_array = { header: "Amount", dataKey: "sub_total" };

      // if (localStorage.setting_location == "true") {
      //   invoice_pdf_header.splice(2, 0, location_array);
      // }
      if (localStorage.setting_grade == "true") {
        invoice_pdf_header.splice(2, 0, grade_array);
      }

      if (this.checkbox_price == true) {
        invoice_pdf_header.splice(8, 0, price_array);
        invoice_pdf_header.splice(9, 0, Amount_array);
      }
      for (var i = 0; i < this.formatted_array2.length; i++) {
        this.$set(this.formatted_array2[i], "row_no", i + 1);
      }

      doc.autoTable({
        pageBreak: "auto",
        startY: 55,
        theme: "grid",
        showHead: "firstPage",
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);
          doc.setFontStyle("normal");

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, 100, pageHeight - 10);
        },
        headStyles: {
          fillColor: [224, 224, 224],
          textColor: 10,
          fontSize: 11,
        },

        columnStyles: {
          row_no: { columnWidth: 8, fontStyle: "bold" },
          product_name: { columnWidth: 25, fontStyle: "bold" },
          grade: { columnWidth: 10 },
          location: { columnWidth: 10 },
          weight: { columnWidth: 30 },
          quantity: { columnWidth: 6 },
          // basket_used: { columnWidth: 10},
          total_real_weight: { columnWidth: 10, fontStyle: "bold" },
        },
        columns: invoice_pdf_header,
        body: this.formatted_array2,
      });
      if (this.checkbox_price == true) {
        doc.text(
          155,
          doc.autoTable.previous.finalY + 10,
          "TOTAL: " + this.currency + parseFloat(total_amount).toFixed(2)
        );
      }
      //////after auto table
      if (doc.autoTable.previous.finalY > 240) {
        doc.addPage();
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(15, 20, 192, 20);

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, 26, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(140, 37, 192, 37);

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, 42, "Name:");
        doc.text(140, 47, "Date:");
      } else {
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(
          140,
          doc.autoTable.previous.finalY + 42,
          192,
          doc.autoTable.previous.finalY + 42
        );

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
        doc.text(140, doc.autoTable.previous.finalY + 52, "Date:");
      }

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Basket?", dataKey: "basket_used" },
        { header: "Total Weight", dataKey: "total_real_weight" },
      ];
      doc.save("PO-" + farmer_name + "-" + date + ".pdf");
    },

    print_bulk_po(array) {
      

      var doc = new jsPDF();

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);


      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(15, 45, "Purchase Bills");

      doc.setLineWidth(0.3);
      doc.line(15, 54, 192, 54);
        var start_y=70;


      for(var c=0; c<array.length; c++){
        doc.setFontSize(11);
      doc.setFontStyle("bold");

      doc.text(15, start_y-5, "Farmer:");
      doc.text(15, start_y-1, "PO ID:");
      doc.text(30, start_y-5, array[c].farmer);
      doc.text(30, start_y-1, ""+array[c].po_id);
      
      var po_array_for_print=array[c].data;
      this.formatted_array2 = [];
      var formatted_array = [];
      var total_amount = 0;
      for (var i = 0; i < po_array_for_print.length; i++) {
        formatted_array[i] = po_array_for_print[i];

        console.log(po_array_for_print[i].total_real_weight);

        var price_float = parseFloat(po_array_for_print[i].price);
        var total_real_weight_float = parseFloat(
          po_array_for_print[i].total_real_weight
        );
        var sub_total = price_float * total_real_weight_float;

        total_amount = parseFloat(total_amount) + parseFloat(sub_total);
        this.$set(formatted_array[i], "sub_total", parseFloat(sub_total));
        // this.$set(formatted_array[i], "row_no", i + 1);
      }

      for (var g = 0; g < formatted_array.length; g++) {
        this.find(
          formatted_array[g].product_name,
          formatted_array[g].grade,
          formatted_array[g].location,
          formatted_array[g].weight,
          formatted_array[g].quantity,
          formatted_array[g].product_id,
          formatted_array[g].basket_item_quantity,
          formatted_array[g].total_real_weight,
          formatted_array[g].sub_total,
          formatted_array[g].price
        );

        if(g==formatted_array.length-1){
          for(var z=0; z<this.formatted_array2.length; z++){
            
            var split_array = this.formatted_array2[z].weight.split(",");

            if(split_array[0]=='box'){
              this.formatted_array2[z].weight=split_array.length +'box';
            }
            if(split_array[0]=='pkt'){
              this.formatted_array2[z].weight=split_array.length +'pkt';
            }
            if(split_array[0]=='pcs'){
              this.formatted_array2[z].weight=split_array.length +'pcs';
            }
            if(split_array[0]=='bag'){
              this.formatted_array2[z].weight=split_array.length +'bag';
            }

          }
        }
      }

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        //  { header: "Basket?", dataKey: "basket_used" },
        { header: "Price", dataKey: "price" },
      ];

      var grade_array = { header: "Grade", dataKey: "grade" };
      var location_array = { header: "Location", dataKey: "location" };
      var price_array = { header: "Price/kg", dataKey: "price" };
      var Amount_array = { header: "Amount", dataKey: "sub_total" };

      // if (localStorage.setting_location == "true") {
      //   invoice_pdf_header.splice(2, 0, location_array);
      // }
      if (localStorage.setting_grade == "true") {
        invoice_pdf_header.splice(2, 0, grade_array);
      }

      if (this.checkbox_price == true) {
        invoice_pdf_header.splice(8, 0, price_array);
        invoice_pdf_header.splice(9, 0, Amount_array);
      }
      for (var i = 0; i < this.formatted_array2.length; i++) {
        this.$set(this.formatted_array2[i], "row_no", i + 1);
      }

      doc.autoTable({
        pageBreak: "auto",
        startY: start_y,
        theme: "grid",
        showHead: "firstPage",
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);
          doc.setFontStyle("normal");

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, 100, pageHeight - 10);
        },
        headStyles: {
          fillColor: [224, 224, 224],
          textColor: 10,
          fontSize: 11,
        },

        columnStyles: {
          row_no: { columnWidth: 8, fontStyle: "bold" },
          product_name: { columnWidth: 25, fontStyle: "bold" },
          grade: { columnWidth: 10 },
          location: { columnWidth: 10 },
          weight: { columnWidth: 30 },
          quantity: { columnWidth: 6 },
          // basket_used: { columnWidth: 10},
          total_real_weight: { columnWidth: 10, fontStyle: "bold" },
        },
        columns: invoice_pdf_header,
        body: this.formatted_array2,
      });
      // if (this.checkbox_price == true) {
        // doc.text(
        //   155,
        //   doc.autoTable.previous.finalY + 5,
        //   // "TOTAL: " + this.currency + parseFloat(total_amount).toFixed(2)
        //   "TOTAL: " 
        // );
      // }
      //////after auto table
      // if (doc.autoTable.previous.finalY > 240) {
      //   doc.addPage();
      //   doc.setDrawColor(0, 0, 0);
      //   doc.setLineWidth(0.3);
      //   doc.line(15, 20, 192, 20);

      //   doc.setFontSize(12);
      //   doc.setFontStyle("normal");
      //   doc.text(140, 26, "RECIEVED:");

      //   doc.setLineWidth(0.1);
      //   doc.line(140, 37, 192, 37);

      //   doc.setFontSize(10);
      //   doc.setFontStyle("normal");
      //   doc.text(140, 42, "Name:");
      //   doc.text(140, 47, "Date:");
      // } else {
      //   doc.setDrawColor(0, 0, 0);
      //   doc.setLineWidth(0.3);
      //   doc.line(
      //     15,
      //     doc.autoTable.previous.finalY + 25,
      //     192,
      //     doc.autoTable.previous.finalY + 25
      //   );

      //   doc.setFontSize(12);
      //   doc.setFontStyle("normal");
      //   doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

      //   doc.setLineWidth(0.1);
      //   doc.line(
      //     140,
      //     doc.autoTable.previous.finalY + 42,
      //     192,
      //     doc.autoTable.previous.finalY + 42
      //   );

      //   doc.setFontSize(10);
      //   doc.setFontStyle("normal");
      //   doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
      //   doc.text(140, doc.autoTable.previous.finalY + 52, "Date:");
      // }

      // var img = "@/assets/image/broccoli.jpeg";
      start_y=doc.autoTable.previous.finalY+20;
      doc.autoTable.previous.finalY = 0;
      invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Basket?", dataKey: "basket_used" },
        { header: "Total Weight", dataKey: "total_real_weight" },
      ];

      }

      doc.save("POs.pdf");
    },

    print_sewa(po_id, date, farmer_name) {
      console.log();
      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "ID: ");
      doc.text(158, 20, "Date: ");
      doc.text(148, 25, "Farmer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#PO" + po_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(farmer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Farmer Vege Date (Sewa):");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(65, 45, date);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      this.sewa_array_for_print[0].total_sewa =
        "RM" +
        parseFloat(
          parseFloat(this.sewa_array_for_print[0].total_sewa) > -1
            ? this.sewa_array_for_print[0].total_sewa
            : "0"
        ).toFixed(2);
      this.sewa_array_for_print[0].total_weight =
        (parseFloat(this.sewa_array_for_print[0].total_weight) > -1
          ? this.sewa_array_for_print[0].total_weight
          : "0") + "kg";
      this.sewa_array_for_print[0].sewa_price =
        "RM" + parseFloat(this.sewa_array_for_print[0].sewa_price).toFixed(2);

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "Total Weight", dataKey: "total_weight" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Price per KG", dataKey: "sewa_price" },
        { header: "Total Amount", dataKey: "total_sewa" },
      ];

      doc.autoTable({
        pageBreak: "auto",
        startY: 55,
        theme: "grid",

        headStyles: {
          fillColor: [224, 224, 224],
          textColor: 10,
          fontSize: 11,
        },

        columnStyles: {
          total_weight: { columnWidth: 30 },
          sewa_price: { columnWidth: 30 },
          total_sewa: { columnWidth: 10, fontStyle: "bold", fontSize: 12 },
        },
        columns: invoice_pdf_header,
        body: this.sewa_array_for_print,
      });

      //////after auto table

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.3);
      doc.line(
        15,
        doc.autoTable.previous.finalY + 25,
        192,
        doc.autoTable.previous.finalY + 25
      );

      doc.setFontSize(12);
      doc.setFontStyle("normal");
      doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

      doc.setLineWidth(0.1);
      doc.line(
        140,
        doc.autoTable.previous.finalY + 42,
        192,
        doc.autoTable.previous.finalY + 42
      );

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
      doc.text(140, doc.autoTable.previous.finalY + 52, "Date:");

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;

      doc.save("PO(Sewa)-" + farmer_name + "-" + date + ".pdf");
    },

    deletePO(po_id) {
      if (confirm("Do you really want to delete?")) {
        const params = new URLSearchParams();
        params.append("delete", "1");
        params.append("po_id", po_id);
        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/purchase_order.php",

          data: params,
        })
          .then((response) => {
            if (response.data.status == "1") {
              this.snackbar_response = true;
              this.response_detail = "delete success";
              console.log(response.data.status);
              this.fetch_po(
                this.$refs.datepicker.date1,
                this.$refs.datepicker.date2
              );
            } else {
              this.snackbar_response = true;
              this.response_detail = "Something Wrong";
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar_connection = true;
          });
      }
    },

    check_own_basket(
      po_id,
      date,
      farmer_name,
      basket_type,
      basket_quantity,
      ref_id
    ) {
      const params = new URLSearchParams();
      params.append("getFarmerBasketRecordForPO", "getFarmerBasketRecordForDO");
      params.append("po_id", po_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/basket/basket_farmer.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == false) {
            var basket = [];

            basket = response.data.data;
            this.own_basket = basket[0].quantity;
            // this.get_basket(po_id, date, farmer_name, basket_quantity);
            this.print_po(
              po_id,
              date,
              farmer_name,
              basket_type,
              basket_quantity,
              ref_id
            );
          } else if (response.data.error == true) {
            this.own_basket = 0;
            // this.get_basket(po_id, date, farmer_name, basket_quantity);
            this.print_po(
              po_id,
              date,
              farmer_name,
              basket_type,
              basket_quantity,
              ref_id
            );
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.po_list_array.slice();
    },
    find(
      product_name,
      grade,
      location,
      weight,
      quantity,
      product_id,
      basket_item_quantity,
      total_real_weight,
      sub_total,
      price
    ) {
      var box_quantity = 0;
      var vege_quantity = 0;
      var basket_used = "";

      if (parseFloat(basket_item_quantity) > 0) {
        basket_used = "Basket";
      } else {
        basket_used = "No Basket";
      }
      console.log(basket_used);
      for (var g = 0; g < this.formatted_array2.length; g++) {
        if (
          this.formatted_array2[g].grade == grade &&
          this.formatted_array2[g].location == location &&
          this.formatted_array2[g].product_id == product_id &&
          this.formatted_array2[g].basket_used == basket_used
        ) {
          for (var j = 0; j < quantity; j++) {

            this.formatted_array2[g].weight =
            this.formatted_array2[g].weight + "," + weight;
            this.formatted_array2[g].quantity++;

          }
          this.formatted_array2[g].basket_item_quantity =
            parseFloat(this.formatted_array2[g].basket_item_quantity) +
            parseFloat(basket_item_quantity);

          this.formatted_array2[g].total_real_weight =
            parseFloat(this.formatted_array2[g].total_real_weight) +
            parseFloat(total_real_weight);

          this.formatted_array2[g].sub_total =
            parseFloat(this.formatted_array2[g].sub_total) +
            parseFloat(sub_total);
          return;
        }
      }

      var single_weight = "";

      for (var i = 0; i < quantity; i++) {
        single_weight =
          (single_weight == "" ? "" : single_weight + ",") + weight;
      }

      this.formatted_array2.push({
        product_name: product_name,
        grade: grade,
        location: location,
        weight: single_weight,
        quantity: quantity,
        product_id: product_id,
        basket_item_quantity: basket_item_quantity,
        basket_used: basket_used,
        total_real_weight: total_real_weight,
        sub_total: sub_total,
        price: price,
      });
    },
    // get_basket(po_id, date, farmer_name, basket_quantity) {
    //   const params = new URLSearchParams();
    //   params.append("readDOBasket", "readDOBasket");
    //   params.append("do_id", do_id);

    //   axios({
    //     method: "post",
    //     url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
    //     data: params
    //   })
    //     .then(response => {
    //       if (response.data.error == false) {
    //         var quantity = [];
    //         quantity = response.data.data;

    //         for (var g = 0; g < quantity.length; g++) {
    //           var basket_q = quantity[g].quantity;
    //           this.basket_in_quantity = basket_q;
    //         }
    //         this.print_do(do_id, date, customer_name, basket_quantity);

    //       } else if (response.data.error == true) {
    //         this.basket_in_quantity = "0";
    //         this.print_do(do_id, date, customer_name, basket_quantity);

    //       }

    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.snackbar = true;
    //     });
    // },
  },
  mounted() {
    // Run the functions once when mounted
    // Run the intervalFetchData function once to set the interval time for later refresh
    // this.intervalFetchData();
  },
};
</script>

